"use client";

import { PropsWithChildren } from "react";
import { usePathname } from "next/navigation";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
export const FooterLogic = ({
  children
}: PropsWithChildren) => {
  const pathname = usePathname();
  const [isMobile] = useMediaQuery("(max-width: 767px)");
  const shouldShowFooter = !(pathname?.startsWith("/vacation-rentals") || pathname?.startsWith("/BookingDetail") || pathname?.startsWith("/my-profile") || pathname?.startsWith("/receipt") || pathname?.endsWith("/manage-payment") || pathname?.endsWith("/messages") || pathname?.startsWith("/payment") && isMobile);
  return shouldShowFooter ? <>{children}</> : null;
};